import env from '../../env';
import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

const jwtHeaders = () => ({
  jwt: localStorage.getItem('microsoftJWT'),
  Accept: 'application/json',
  'Content-Type': 'application/json',
});

export const getPaletteItems = createAsyncThunk(
  'palette/getPaletteItems',
  async (params = {}, { rejectWithValue }) => {
    const page = params.page || 1;
    const pageSize = params.pageSize || 50;
    try {
      const { data } = await axios.get(
        `${env.API_URL}/articles?pagination[page]=${page}&pagination[pageSize]=${pageSize}&filters[$or][0][paletteNo][$notNull]=true&filters[$or][1][boxNo][$notNull]=true&sort=updatedAt:desc&populate=*`,
        { headers: jwtHeaders() }
      );
      return data;
    } catch (err) {
      return rejectWithValue(err?.response?.data ?? { message: 'Unknown error' });
    }
  }
);

export const searchPaletteItems = createAsyncThunk(
  'palette/searchPaletteItems',
  async (payload, { rejectWithValue }) => {
    const { term = '', page = 1, pageSize = 50, match = 'contains', fields } = payload || {};
    const encoded = encodeURIComponent(term || '');
    const operator = match === 'exact' ? '$eq' : '$contains';
    const defaultFields = ['paletteNo', 'boxNo', 'newSerial', 'serial', 'rma.number', 'skuNumber', 'newSku'];
    const useFields = Array.isArray(fields) && fields.length > 0 ? fields : defaultFields;
    const orParts = useFields
      .map((field, idx) => {
        const path = String(field).replace(/\./g, '][');
        return `filters[$or][${idx}][${path}][${operator}]=${encoded}`;
      })
      .join('&');
    const url = `${env.API_URL}/articles?pagination[page]=${page}&pagination[pageSize]=${pageSize}&${orParts}&sort=updatedAt:desc&populate=*`;
    try {
      const { data } = await axios.get(url, { headers: jwtHeaders() });
      return data;
    } catch (err) {
      return rejectWithValue(err?.response?.data ?? { message: 'Unknown error' });
    }
  }
);
